import React from "react";

let FormeInput =React.forwardRef((props ,ref)=>{

    return (
           <div className="mb-3 col-md-6">
                <label className="htmlForm-label">{props.title}</label>
                <input 
                type={props.type} 
                className={`Form-control ${props.inputClass}`}
                 aria-describedby="" 
                 ref={ref}
        
                 /> 
           </div>
    );
});



// function FormeInput(props){
//     return (
//    <div className="mb-3 col-md-6">
//         <label className="htmlForm-label">{props.title}</label>
//         <input 
//         type={props.type} 
//         className={`Form-control ${props.inputClass}`}
//          aria-describedby="" 
//          ref={props.inputRef}

//          /> 
//    </div>    
//     );
// }
export default FormeInput;